import styles from './Disclaimer.module.css';
import { Container } from '..';

export const Disclaimer = () => {
  return (
    <section className={styles.disclaimerSection}>
      <Container>
        <p>
          The Ultrahuman Fertile Window feature provides educational information
          about menstrual cycle phases and potential fertility patterns to help
          women understand their body&apos;s natural rhythms. It is not intended
          for use as a contraceptive, a sole method to achieve pregnancy, a
          medical diagnostic tool, or a substitute for professional medical
          advice. Insights are based on individual biomarker patterns and
          statistical data, but cycle variations may occur, and actual fertility
          windows may differ. For medical advice, diagnosis, treatment, or
          guidance on fertility, conception, or contraception, consult a
          qualified healthcare provider.
        </p>
      </Container>
    </section>
  );
};
